import { render, staticRenderFns } from "./DetailKasMutasi.vue?vue&type=template&id=53dfe4a4&"
import script from "./DetailKasMutasi.vue?vue&type=script&lang=js&"
export * from "./DetailKasMutasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports